/**
 * 日付フォーマット
 */
export const DATE_TIME_FORMAT = {
  JA_YEAR_MONTH: 'yyyy年MM月',
  JA_MONTH_DAY: 'MM月dd日',
  JA_YEAR_MONTH_DAY: 'yyyy年MM月dd日',
  SLASH_YEAR_MONTH: 'yyyy/MM',
  SLASH_DATE_FORMAT: 'yyyy/MM/dd',
  HYPHEN_DATE_FORMAT: 'yyyy-MM-dd',
  WEEKDAY_SLASH_DATE_FORMAT: 'yyyy/MM/dd (eee)',
  WEEKDAY_SLASH_DATE_FORMAT_WIJMO: 'yyyy/MM/dd (ddd)',
  WEEKDAY_HYPHEN_DATE_FORMAT: 'yyyy-MM-dd (eee)',
  SLASH_DATE_TIME_FORMAT: 'yyyy/MM/dd HH:mm',
  SLASH_DATE_TIME_FORMAT_NO_YEAR: 'MM/dd HH:mm',
  HYPHEN_DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm',
  DATE_TIME_SECOND_FORMAT: 'yyyyMMddHHmmss',
  WEEKDAY_SLASH_DATE_TIME_FORMAT: 'yyyy/MM/dd (eee) HH:mm',
  WEEKDAY_HYPHEN_DATE_TIME_FORMAT: 'yyyy-MM-dd (eee) HH:mm',
  WEEKDAY_SLASH_DATE_TIME_SECOND_FORMAT: 'yyyy/MM/dd (eee) HH:mm:ss',
  WEEKDAY_HYPHEN_DATE_TIME_SECOND_FORMAT: 'yyyy-MM-dd (eee) HH:mm:ss',
  TIME_FORMAT: 'HH:mm',
  TIME_SECOND_FORMAT: 'HH:mm:ss',
  UTC_TIME_FORMAT: 'HH:mm Z',
  UTC_TIME_SECOND_FORMAT: 'HH:mm:ss Z',
  SLASH_DATE_TIME_SECOND_FORMAT: 'yyyy/MM/dd HH:mm:ss',
  SLASH_DATE_FORMAT_NO_YEAR: 'MM/dd',
  DATE_TIME_TZ_FORMAT: 'yyyy-MM-dd HH:mm:ssXXX',
  DATE_TIME_TZ_ISO_FORMAT: "yyyy-MM-dd'T'HH:mm:ssXXX",
} as const;

/**
 * タイムゾーンの一覧
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 */
export const TIME_ZONES = {
  TOKYO: 'Asia/Tokyo',
  NEW_YORK: 'America/New_York',
} as const;
